var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-slider"},[_c('input',{ref:"slider",staticClass:"slider",attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":String(_vm.value)},on:{"input":_vm.handleRangeChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }